import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
// import Snackbar from '@material-ui/core/Snackbar';
// import MuiAlert from '@material-ui/lab/Alert';

//import AppBar from './components/AppBar';
import SideBar from 'components/SideBar'


// function Alert(props) {
// 	return <MuiAlert elevation={6} variant="filled" {...props} />;
// }

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        height: '100vh', //  '100%',
        overflow: 'hidden',
    },
    // toolbar: {
    //     display: 'flex',
    //     alignItems: 'center',
    //     justifyContent: 'flex-end',
    //     padding: theme.spacing(0, 1),
    //     ...theme.mixins.toolbar,
    // },
    content: {
        flexGrow: 1,
        flexDirection: 'column',
        display: 'flex',
    },
    contentMain: {
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
        paddingTop: theme.spacing(1),
        paddingRight: theme.spacing(2),
    }
}));




const MainAppLayout = (props) => {
    const { children, toolbar } = props;
    
    const classes = useStyles();

    
    // const snackBarOpen = editorMessage ? true: false;
    // const snackBarMessage = editorMessage ? editorMessage.message: "";
    // const snackBarSeverity = editorMessage ? editorMessage.severity: "warning";
    
    // const [open, setOpen] = React.useState(false);

    // const handleDrawerOpen = () => {
    //     setOpen(true);
    // };

    // const handleDrawerClose = () => {
    //     setOpen(false);
    // };

    // const handleSnackBarClose = () => {
    //     dispatch(removeEditorMessage())
    // }

    return (
        <div className={classes.root}>
            <SideBar/>
            <main className={classes.content}>
                {toolbar ? toolbar: null}
                <div className={classes.contentMain}>
                    {children}
                </div>
            </main>
        </div>
    );
}

export default MainAppLayout;


